const arrowPositions = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
};
const arrowRotations = {
    top: '0',
    right: '90deg',
    bottom: '180deg',
    left: '270deg',
};
const staticPositions = {
    top: '-10px',
    right: '-15px',
    bottom: '-10px',
    left: '-15px',
};
const arrowPaddings = {
    start: -3,
    end: 3,
};
export const getArrowStyles = (internalArrowPosition, tooltipPlacement) => {
    var _a;
    const [primaryPosition, secondaryPosition] = tooltipPlacement.split('-');
    const staticSide = arrowPositions[primaryPosition];
    const staticPosition = staticPositions[primaryPosition];
    const arrowRotation = arrowRotations[primaryPosition];
    const arrowPadding = (_a = arrowPaddings[secondaryPosition]) !== null && _a !== void 0 ? _a : 0;
    return Object.assign(Object.assign(Object.assign({}, ((internalArrowPosition === null || internalArrowPosition === void 0 ? void 0 : internalArrowPosition.x) != null
        ? { left: `${internalArrowPosition.x + arrowPadding}px` }
        : {})), ((internalArrowPosition === null || internalArrowPosition === void 0 ? void 0 : internalArrowPosition.y) != null
        ? { top: `${internalArrowPosition.y + -arrowPadding}px` }
        : {})), { transform: `rotate(${arrowRotation})`, [staticSide]: staticPosition });
};
